// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import model_1 from '/home/node/app/src/models/chatbot';
import model_2 from '/home/node/app/src/models/notification';
import model_3 from '/home/node/app/src/models/report';
import model_4 from '/home/node/app/src/models/websocket';
import model_5 from '/home/node/app/src/.umi-production/plugin-initialState/@@initialState';

export const models = {
model_1: { namespace: 'chatbot', model: model_1 },
model_2: { namespace: 'notification', model: model_2 },
model_3: { namespace: 'report', model: model_3 },
model_4: { namespace: 'websocket', model: model_4 },
model_5: { namespace: '@@initialState', model: model_5 },
} as const
